import { useState } from "react";
import { CalendarPlus, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTaskCalendarEvent } from "@/hooks/useTaskCalendarEvent";
import { AddToCalendarDialog } from "./AddToCalendarDialog";

interface Props {
	projectId: string;
	taskId: string;
	taskTitle: string;
	estimatedTime: number; // minutes
}

export function CalendarButton({
	projectId,
	taskId,
	taskTitle,
	estimatedTime,
}: Props) {
	const { event, loading, creating, create } = useTaskCalendarEvent(
		projectId,
		taskId,
	);
	const [dialogOpen, setDialogOpen] = useState(false);

	if (event) {
		return (
			<Button
				variant="primary_outline"
				size="sm"
				className="text-foreground"
				disabled={!event.html_link}
				onClick={() =>
					event.html_link &&
					window.open(event.html_link, "_blank", "noopener,noreferrer")
				}
			>
				<CalendarCheck className="h-3.5 w-3.5" />
				<span className="text-[12px]">Calendar Event Link</span>
			</Button>
		);
	}

	return (
		<>
			<Button
				variant="primary_outline"
				size="sm"
				className="text-foreground"
				disabled={loading}
				onClick={() => setDialogOpen(true)}
			>
				<CalendarPlus className="h-3.5 w-3.5" />
				<span className="text-[12px]">Add to Calendar</span>
			</Button>
			<AddToCalendarDialog
				open={dialogOpen}
				onOpenChange={setDialogOpen}
				taskTitle={taskTitle}
				defaultDurationMin={estimatedTime}
				creating={creating}
				onConfirm={create}
			/>
		</>
	);
}
